import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { colors, indents, textSizes } from 'theme'
import grid from 'blocks.simple/grid/grid.jcss'

export const secondFactorActionStyles: IStyles = {
    overlay: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        padding: indents.md,
        boxSizing: 'border-box',
        overflowY: 'auto',
    },
    modal: {
        width: '100%',
        maxWidth: 656,
        background: colors.white,
        borderRadius: 20,
        border: '1px solid #f0f0f0',
        boxShadow: '0px 4px 20px 0px rgba(0,0,0,0.05)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
    },
    modalWide: {
        maxWidth: 794,
    },
    header: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.justify,
        padding: '20px 24px 16px',
        borderBottom: '1px solid rgba(26, 26, 35, 0.12)',
        gap: indents.md,
    },
    title: {
        flex: 1,
        fontWeight: 500,
        fontSize: 24,
        lineHeight: '32px',
        color: '#1a1a23',
        textAlign: 'left',
    },
    closeBtn: {
        flexShrink: 0,
        width: 24,
        height: 24,
        padding: 0,
        border: 0,
        background: 'transparent',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
        padding: 24,
    },
    stepper: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 12,
        flexWrap: 'wrap',
    },
    stepItem: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 8,
    },
    stepTail: {
        width: 20,
        height: 1,
        background: 'rgba(26, 26, 35, 0.12)',
        flexShrink: 0,
    },
    stepTailDone: {
        background: colors.blueAccent,
    },
    stepBadge: {
        boxSizing: 'border-box',
        width: 24,
        height: 24,
        borderRadius: 1000,
        border: '1px solid rgba(26, 26, 35, 0.36)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgba(26, 26, 35, 0.36)',
        flexShrink: 0,
    },
    stepBadgeCurrent: {
        borderColor: colors.blueAccent,
        color: colors.blueAccent,
    },
    stepBadgeDone: {
        borderColor: colors.blueAccent,
        background: colors.blueAccent,
        color: colors.white,
    },
    stepLabel: {
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgba(26, 26, 35, 0.6)',
        whiteSpace: 'nowrap',
    },
    stepLabelActive: {
        color: '#1a1a23',
    },
    lead: {
        fontSize: 16,
        lineHeight: '20px',
        color: '#1a1a23',
    },
    recoveryBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 24,
        width: '100%',
    },
    recoveryLead: {
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.84)',
    },
    muted: {
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.36)',
    },
    mutedStrong: {
        color: 'rgba(26, 26, 35, 0.84)',
    },
    resendRow: {
        ...grid.row,
        gap: 4,
        flexWrap: 'wrap',
        fontSize: 14,
        lineHeight: '20px',
    },
    error: {
        color: colors.error,
        fontSize: textSizes.normal,
    },
    qrLayout: {
        ...grid.row,
        alignItems: 'flex-start',
        gap: 32,
        flexWrap: 'wrap',
    },
    qrCol: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
        flexShrink: 0,
    },
    qrBox: {
        boxSizing: 'border-box',
        padding: 12,
        background: '#28282a',
        borderRadius: 16,
    },
    qrInner: {
        width: 204,
        height: 204,
        borderRadius: 8,
        overflow: 'hidden',
        background: colors.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    qrCaption: {
        textAlign: 'center',
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgba(26, 26, 35, 0.6)',
    },
    howtoCol: {
        flex: 1,
        minWidth: 280,
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
    },
    howtoItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    howtoHead: {
        ...grid.row,
        alignItems: 'flex-start',
        gap: 20,
    },
    howtoNum: {
        boxSizing: 'border-box',
        width: 24,
        height: 24,
        borderRadius: 1000,
        border: `1px solid ${colors.blueAccent}`,
        color: colors.blueAccent,
        fontSize: 14,
        lineHeight: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        marginTop: 8,
    },
    howtoText: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    howtoTitle: {
        fontSize: 16,
        lineHeight: '20px',
        color: '#1a1a23',
    },
    howtoDesc: {
        fontSize: 14,
        lineHeight: '16px',
        color: 'rgba(26, 26, 35, 0.6)',
    },
    appsRow: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 12,
        flexWrap: 'wrap',
        paddingLeft: 44,
    },
    appPill: {
        background: 'rgba(26, 26, 35, 0.04)',
        borderRadius: 1000,
        padding: '4px 8px',
        fontSize: 12,
        lineHeight: '16px',
        color: 'rgba(26, 26, 35, 0.84)',
    },
    howtoExtra: {
        paddingLeft: 44,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    linkBtn: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 4,
        padding: 0,
        border: 0,
        background: 'transparent',
        color: colors.blueAccent,
        fontSize: 14,
        lineHeight: '16px',
        cursor: 'pointer',
        textAlign: 'left',
        width: 'fit-content',
    },
    secretPanel: {
        background: 'rgba(40, 108, 242, 0.05)',
        borderRadius: 12,
        padding: indents.md,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        fontSize: 14,
        lineHeight: '20px',
        color: '#1a1a23',
    },
    secretRow: {
        ...grid.row,
        alignItems: 'flex-start',
        gap: 8,
        flexWrap: 'wrap',
    },
    secretKeyLabel: {
        color: 'rgba(26, 26, 35, 0.6)',
        minWidth: 72,
    },
    secretValue: {
        fontFamily: 'monospace',
        letterSpacing: 0.5,
        wordBreak: 'break-all',
        flex: 1,
        minWidth: 0,
    },
    codesBox: {
        boxSizing: 'border-box',
        width: '100%',
        background: 'rgba(40, 108, 242, 0.05)',
        border: '1px solid rgba(26, 26, 35, 0.12)',
        borderRadius: 12,
        padding: '16px 16px 16px 54px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: 12,
    },
    codeItem: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '20px',
        color: '#1a1a23',
        letterSpacing: 0.2,
        wordBreak: 'break-all',
    },
    actionsRow: {
        ...grid.row,
        alignItems: 'stretch',
        gap: 12,
        width: '100%',
    },
    actionBtn: {
        flex: 1,
        minWidth: 0,
    },
    checkboxRow: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        userSelect: 'none',
    },
    doneBlock: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 16,
        width: '100%',
    },
    doneTitle: {
        width: '100%',
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 500,
        lineHeight: '32px',
        color: '#1a1a23',
    },
    doneLead: {
        width: '100%',
        textAlign: 'center',
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.84)',
    },
    doneNotify: {
        width: '100%',
        textAlign: 'center',
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.6)',
    },
    footer: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 10,
        padding: 24,
        borderTop: '1px solid rgba(26, 26, 35, 0.12)',
    },
}

addStyles(secondFactorActionStyles)
